import { Node } from '@tiptap/core';
import { VueNodeViewRenderer } from '@tiptap/vue-2';
import ColShorttag from './ColShorttag.vue';

export default Node.create({
  name: 'ColShorttag',
  group: 'block',
  content: 'block+',
  defining: true,
  isolating: true,
  allowGapCursor: true,
  components: {
    ...ColShorttag.components,
  },
  addAttributes() {
    return {
      ...ColShorttag.props,
    };
  },
  parseHTML() {
    return [
      {
        tag: 'col-shorttag',
      },
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const classString = `col-${Math.floor(12 / HTMLAttributes.colCountXS)} col-md-${Math.floor(12 / HTMLAttributes.colCountMD)} col-lg-${Math.floor(12 / HTMLAttributes.colCountLG)}`;
    return ['div', { class: classString }, 0];
  },
  addNodeView() {
    return VueNodeViewRenderer(ColShorttag);
  },
});
